import { IMappedGroupScheduleWithoutDate } from 'entities/types';

export function getMinMaxTimes(items: IMappedGroupScheduleWithoutDate[]) {
  // Группируем элементы по isEven
  const grouped: Record<string, IMappedGroupScheduleWithoutDate[]> = {
    true: [],
    false: [],
  };

  items.forEach((item) => {
    grouped[String(item.isEven)].push(item);
  });

  // Функция для сравнения двух временных строк
  const compareTimes = (time1: string, time2: string) => {
    const [h1, m1] = time1.split(':').map(Number);
    const [h2, m2] = time2.split(':').map(Number);

    if (h1 !== h2) return h1 - h2;
    return m1 - m2;
  };

  // Результат
  const result: Record<string, { start?: string; end?: string }> = {
    true: {},
    false: {},
  };

  // Для каждой группы находим min и max
  (['true', 'false'] as const).forEach((key) => {
    const group = grouped[key];
    if (group.length === 0) return;

    let minTime = group[0].disciplTime;
    let maxTime = group[0].disciplTime;

    for (let i = 1; i < group.length; i++) {
      const currentTime = group[i].disciplTime;
      if (compareTimes(currentTime, minTime) < 0) {
        minTime = currentTime;
      }
      if (compareTimes(currentTime, maxTime) > 0) {
        maxTime = currentTime;
      }
    }

    result[key] = { start: minTime, end: maxTime };
  });

  return {
    evenTime: result.true.end ? result.true : null,
    oddTime: result.false.end ? result.false : null,
  };
}
